import { GREAT_WHITE } from 'HubStyleTokens/colors';
export const borderStyle = `1px solid ${GREAT_WHITE}`;